import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss, Flex, Box } from '@atlaskit/primitives';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';

import { messages } from '../../messages';

const scriptFooterStyles = xcss({
	paddingBlock: 'space.100',
	paddingInline: 'space.050',
	color: 'color.text.subtlest',
	font: token('font.body.small'),
});

export const LoomScriptPanelFooter = () => {
	return (
		<Flex alignItems="center" justifyContent="space-between" wrap="wrap">
			<Flex alignItems="center" gap="space.025" wrap="wrap">
				<InformationCircleIcon label="Script footer" />
				<Box xcss={scriptFooterStyles}>
					<FormattedMessage {...messages.loomScriptFooter} />
				</Box>
			</Flex>
			<Flex xcss={scriptFooterStyles} alignItems="center" gap="space.050">
				<FormattedMessage {...messages.aiBadgeText} />
				<AtlassianIntelligenceIcon label="AI icon" />
			</Flex>
		</Flex>
	);
};
